import { Card } from "@/components/ui/card";

const Problem = () => {
  return (
    <section id="problem" className="py-16">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-8">
          <Card className="p-8 bg-panel border-border">
            <h2 className="text-2xl font-bold text-foreground mb-4">For Home Buyers</h2>
            <p className="text-muted-foreground leading-relaxed">
              Buying a home is harder than ever. Down payments are the biggest barrier, even for qualified buyers. 
              SmartEQT™ helps buyers purchase without needing the traditional 20% down payment — with no PMI and no additional debt.
            </p>
          </Card>
          
          <Card className="p-8 bg-panel border-border">
            <h2 className="text-2xl font-bold text-foreground mb-4">For Investors</h2>
            <p className="text-muted-foreground leading-relaxed">
              Residential real estate is the largest illiquid asset class — locked equity with limited entry points.
            </p>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Problem;